import classNames from "classnames";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import {
    BILL_SCHEDULE_BLOCK_MESSAGES,
    BillScheduleBlockReason,
} from "@common/helpers/domains/accounting/billScheduleEligibility";
import { pluralizeWithCount } from "@common/helpers/string";
import { ScheduleCard } from "@components/accounting/schedules/ScheduleCard";
import { ScheduleUnavailableReason } from "@components/invoices/views/scheduleCellState";
import styles from "@components/invoices/views/ScheduleCellContent.module.scss";
import { BillScheduleCellState } from "./billScheduleCellState";

const UNAVAILABLE_TOOLTIPS: Record<
    ScheduleUnavailableReason | BillScheduleBlockReason,
    string
> = {
    ...BILL_SCHEDULE_BLOCK_MESSAGES,
    [ScheduleUnavailableReason.derivedLine]:
        "Tax and discount lines follow the line they came from",
    [ScheduleUnavailableReason.zeroAmount]: "There is no amount to schedule",
};

interface Props {
    state: Extract<
        BillScheduleCellState,
        { kind: "partial" | "wholeBill" | "unavailable" }
    >;
}

export const BillScheduleCellContent = ({ state }: Props) => {
    if (state.kind === "wholeBill") {
        return (
            <ScheduleCard
                schedule={state.schedule}
                tooltipContent="The whole bill is scheduled. Switch to By bill to change it."
            />
        );
    }

    if (state.kind === "partial") {
        return (
            <Tooltip content="Some lines are scheduled. Switch to By line item to see or change them.">
                <span className={classNames(styles.muted, styles.partial)}>
                    {`Partially scheduled (${pluralizeWithCount(
                        "line",
                        state.scheduledLineCount,
                    )})`}
                </span>
            </Tooltip>
        );
    }

    return (
        <Tooltip content={UNAVAILABLE_TOOLTIPS[state.reason]}>
            <span className={styles.muted}>-</span>
        </Tooltip>
    );
};
